module.exports = __webpack_public_path__ + "static/img/craftbeers.f136598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/craftbeers.jpg
// module id = //XJ
// module chunks = 0